import React, { useState, useEffect } from 'react';

const COLORS = ['#10b981','#3b82f6','#f59e0b','#f97316','#ef4444'];

const StressGauge = ({ score }) => {
  const [animated, setAnimated] = useState(0);
  useEffect(() => { const t = setTimeout(() => setAnimated(score), 100); return () => clearTimeout(t); }, [score]);

  const color = score < 20 ? COLORS[0] : score < 40 ? COLORS[1] : score < 60 ? COLORS[2] : score < 80 ? COLORS[3] : COLORS[4];
  const circumference = Math.PI * 80;
  const progress = (animated / 100) * circumference;

  return (
    <div className="relative w-56 h-32 mx-auto">
      <svg viewBox="0 0 200 110" className="w-full h-full">
        <path d="M 20 95 A 80 80 0 0 1 180 95" fill="none" stroke="#e5e7eb" strokeWidth="16" strokeLinecap="round"/>
        <path d="M 20 95 A 80 80 0 0 1 180 95" fill="none" stroke={color} strokeWidth="16" strokeLinecap="round"
          strokeDasharray={`${progress} ${circumference}`}
          style={{ transition: 'stroke-dasharray 1.2s cubic-bezier(0.4,0,0.2,1)' }}/>
        <g transform={`rotate(${(animated / 100) * 180 - 90} 100 95)`}
           style={{ transition: 'transform 1.2s cubic-bezier(0.4,0,0.2,1)' }}>
          <line x1="100" y1="95" x2="100" y2="28" stroke="#374151" strokeWidth="3" strokeLinecap="round"/>
          <circle cx="100" cy="95" r="7" fill="#374151"/>
          <circle cx="100" cy="95" r="3" fill={color}/>
        </g>
      </svg>
      <div className="absolute inset-0 flex items-end justify-center pb-2">
        <div className="text-center">
          <div className="text-4xl font-bold" style={{ color }}>{Math.round(score)}</div>
          <div className="text-xs text-gray-500">Stress Score</div>
        </div>
      </div>
    </div>
  );
};

export default StressGauge;
